import { FormValidations } from "features/shared/forms/hooks/useForm";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";

export const paymentMethodFormValidations = (): FormValidations  => {
  return {
    depositPaymentTypeCode: {
      required: true,
      type: "OnlyRequired",
      requiredMessage: "paymentMethodFormValidation.paymentMethodType"
    },
    invoicePaymentTypeCode: {
      required: true,
      type: "OnlyRequired",
      requiredMessage: "paymentMethodFormValidation.paymentMethodType"
    },
    overpaidPaymentTypeCode: {
      required: true,
      type: "OnlyRequired",
      requiredMessage: "paymentMethodFormValidation.paymentMethodType"
    },
    depositsAmount: {
      required: true,
      type: "Function",
      validate: validateDepositsAmount,
      message: "paymentMethodFormValidation.depositsAmount"
    } as FunctionValidationRule
  };
}

const validateDepositsAmount = (value: any): boolean => {
  const numberValue = Number(value);

  if (!Number.isInteger(numberValue)) {
    return false;
  }

  if (numberValue <= 0) {
    return false;
  }

  if (numberValue % 100 !== 0) {
    return false;
  }

  if (value.toString().includes('.')) {
    return false;
  }

  return true;
};